// extracted by mini-css-extract-plugin
module.exports = {"main":"AppProfile_main__8EW8K","barContainer":"AppProfile_barContainer__P8lYp","barContainerOwn":"AppProfile_barContainerOwn__rLpFA"};